
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zwangerschapscursus/afrekenen",
      function () {
        return require("private-next-pages/zwangerschapscursus/afrekenen.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zwangerschapscursus/afrekenen"])
      });
    }
  